import api from './api';

export const blogService = {
    // Get all published blogs
    getAllBlogs: async () => {
        const response = await api.get('/blogs');
        return response.data;
    },

    // Get blog by slug
    getBlogBySlug: async (slug) => {
        const response = await api.get(`/blogs/${slug}`);
        return response.data;
    },

    // Get blog by ID (admin)
    getBlogById: async (id) => {
        const response = await api.get(`/blogs/admin/${id}`);
        return response.data;
    },

    // Create new blog (admin)
    createBlog: async (blogData) => {
        const response = await api.post('/blogs', blogData);
        return response.data;
    },

    // Update blog (admin)
    updateBlog: async (id, blogData) => {
        const response = await api.put(`/blogs/${id}`, blogData);
        return response.data;
    },

    // Delete blog (admin)
    deleteBlog: async (id) => {
        const response = await api.delete(`/blogs/${id}`);
        return response.data;
    },

    // Get all blogs including unpublished (admin)
    getAllBlogsAdmin: async () => {
        const response = await api.get('/blogs/admin/all');
        return response.data;
    },
};

